import React, { useState } from 'react';
import { Card, IconButton, Text } from '../ui';
import { Trash2, Edit } from 'lucide-react';
import EditOfferingModal from './EditOfferingModal';

const OfferingCard = ({
  offering,
  index,
  isMobile,
  onSave,
  onDelete,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnter,
  onDragLeave,
  isDragging,
  isDraggedOver,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSave = (id, formData) => {
    onSave(id, formData);
  };

  return (
    <>
      <div className={`transition-all duration-200 ${isDraggedOver && !isDragging ? 'mb-32' : ''}`}>
        <div
          className={`rounded-lg p-4 transition-colors ${
            isDragging ? 'opacity-50 scale-95' : 'opacity-100'
          } ${isDraggedOver && !isDragging ? 'border-2 border-dashed' : ''}`}
          style={{
            border: isDraggedOver && !isDragging ? '2px dashed var(--brand)' : '1px solid var(--border)',
          }}
        >
          <div className='flex justify-between items-start mb-2 gap-2'>
            <div className='flex-1 min-w-0'>
              <Text
                variant='subtitle'
                className={`text-sm font-semibold ${
                  isMobile ? 'text-sm' : ''
                } truncate`}
                style={{ color: 'var(--text-primary)' }}
              >
                {offering.name}
              </Text>
            </div>

            <div className='tour-edit-delete-offering flex gap-2'>
              <IconButton
                icon={Edit}
                tooltip='Edit offering'
                onClick={() => setIsModalOpen(true)}
                variant='ghostPrimary'
                size='sm'
              />
              {onDelete && (
                <IconButton
                  icon={Trash2}
                  tooltip='Delete offering'
                  onClick={() => onDelete(offering.id)}
                  variant='ghostDanger'
                  size='sm'
                />
              )}
            </div>
          </div>

          <Text
            variant='caption'
            className={`text-xs mb-2 block ${isMobile ? 'text-xs' : ''}`}
            style={{ wordBreak: 'break-word', color: 'var(--text-muted)' }}
          >
            {offering.description || 'No description'}
          </Text>

          <div className='flex items-center gap-1 min-w-0'>
            <Text variant='caption' className='text-[10px] uppercase font-bold' style={{ color: 'var(--text-muted)' }}>
              URL:
            </Text>
            {offering.page_url ? (
              <a
                href={offering.page_url}
                target='_blank'
                rel='noopener noreferrer'
                className='text-[10px] hover:underline truncate max-w-full'
                style={{ color: 'var(--brand)' }}
              >
                {offering.page_url}
              </a>
            ) : (
              <Text variant='caption' className='text-[10px]' style={{ color: 'var(--text-faint)' }}>
                Not specified
              </Text>
            )}
          </div>
        </div>
      </div>

      <EditOfferingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        offering={offering}
        onSave={handleSave}
      />
    </>
  );
};

export default OfferingCard;
